(() => {
  if (window.slWhatsAppReady) return;
  window.slWhatsAppReady = true;

  const config = window.slContact || {};
  const HASH = '#enquire';
  const ATTRIBUTION_KEY = 'sl-attribution';
  const ATTRIBUTION_PARAMS = ['fbclid', 'gclid', 'ttclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  /* Keep the ad click ids and UTM tags of the landing page for the rest of the visit. */
  function rememberAttribution() {
    try {
      const params = new URLSearchParams(window.location.search);
      const saved = JSON.parse(sessionStorage.getItem(ATTRIBUTION_KEY) || '{}');
      let changed = false;
      ATTRIBUTION_PARAMS.forEach((name) => {
        const value = params.get(name);
        if (value) {
          saved[name] = value;
          changed = true;
        }
      });
      if (changed) {
        if (params.get('fbclid')) saved.fbclid_at = Date.now();
        saved.landing = window.location.pathname;
        sessionStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(saved));
      }
      return saved;
    } catch (error) {
      return {};
    }
  }

  const attribution = rememberAttribution();

  const cookie = (name) => {
    const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : '';
  };

  const eventId = () =>
    window.crypto && window.crypto.randomUUID
      ? window.crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(16).slice(2)}`;

  function whatsappUrl(treatment) {
    if (!config.number) return '';
    const parts = [config.message || ''];
    if (treatment && config.treatmentMessage) parts.push(`${config.treatmentMessage} ${treatment}.`);
    const text = parts.join(' ').trim();
    return `https://wa.me/${config.number}${text ? `?text=${encodeURIComponent(text)}` : ''}`;
  }

  function isEnquiryTrigger(element) {
    if (element.hasAttribute('data-sl-enquire')) return true;
    if (element.tagName !== 'A') return false;
    const href = element.getAttribute('href') || '';
    if (href === HASH) return true;
    try {
      const url = new URL(href, window.location.href);
      return url.hash === HASH && url.origin === window.location.origin;
    } catch (error) {
      return false;
    }
  }

  const isWhatsAppLink = (element) => element.tagName === 'A' && /(^|\/\/)(wa\.me|api\.whatsapp\.com)\//.test(element.getAttribute('href') || '');

  const formMode = () => config.mode === 'form';

  /* Point every enquiry button and WhatsApp link at the one number, so long press and copy link work too. */
  function prepare(scope) {
    if (!config.number) return;
    scope.querySelectorAll('a, [data-sl-enquire]').forEach((element) => {
      const enquiry = !formMode() && isEnquiryTrigger(element);
      if (!enquiry && !isWhatsAppLink(element)) return;
      const url = whatsappUrl(element.getAttribute('data-sl-treatment'));
      element.setAttribute('data-sl-whatsapp-link', '');
      if (element.tagName === 'A') {
        element.setAttribute('href', url);
        element.setAttribute('target', '_blank');
        element.setAttribute('rel', 'noopener');
      }
    });
  }

  /* One place for ad tracking. A Meta pixel, Google tag or a later Conversions API setup listens here. */
  function track(trigger, url) {
    const treatment = trigger.getAttribute('data-sl-treatment') || '';
    const section = trigger.closest('[id^="shopify-section-"]');
    const detail = {
      eventId: eventId(),
      treatment,
      source: section ? section.id.replace('shopify-section-', '') : '',
      page: window.location.pathname,
      url,
      fbp: cookie('_fbp'),
      fbc: cookie('_fbc') || (attribution.fbclid ? `fb.1.${attribution.fbclid_at || Date.now()}.${attribution.fbclid}` : ''),
      attribution,
    };

    window.dispatchEvent(new CustomEvent('sl:whatsapp', { detail }));

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'whatsapp_click', ...detail });

    if (typeof window.fbq === 'function') {
      window.fbq('track', 'Contact', treatment ? { content_name: treatment } : {}, { eventID: detail.eventId });
    }
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'whatsapp_click', { treatment, source: detail.source });
    }
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-sl-whatsapp-link], a, [data-sl-enquire]');
    if (!trigger) return;
    if (!trigger.hasAttribute('data-sl-whatsapp-link')) {
      const enquiry = !formMode() && isEnquiryTrigger(trigger);
      if (!enquiry && !isWhatsAppLink(trigger)) return;
    }
    const url = whatsappUrl(trigger.getAttribute('data-sl-treatment'));
    if (!url) return;

    track(trigger, url);

    const menu = trigger.closest('details[open]');
    if (menu) menu.removeAttribute('open');

    if (trigger.tagName !== 'A') {
      event.preventDefault();
      window.open(url, '_blank', 'noopener');
    } else if (trigger.getAttribute('href') !== url) {
      trigger.setAttribute('href', url);
    }
  });

  window.slWhatsApp = { url: whatsappUrl, prepare };

  const init = () => prepare(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => prepare(event.target));
})();
